export default "__VITE_ASSET__4zPtLex___"